import React from 'react'
import styles from './finish-signup.styles'
import injectSheet from 'react-jss'
import { UserProvider } from 'pobble-components/dist/pobble-user'
import { apiGetMe } from '../../../common/api/profile'
import Suspense from './suspense/suspense.container'
import Constructor from './constructor/constructor.container'
import Auth from '../../auth/auth'

const getMe = () =>
  apiGetMe({
    include:
      'account.signup_details,account.email_identity.email,account.finish_signup_status,account.teacher_type,account.pending_teacher_type,account.teacher_type.school,account.pending_teacher_type.school,account.subscriptions,account.subscription_policy,account.subscription_prices,account.subscription_currency'
  })

const FinishSignup = ({ classes }) => (
  <Auth>
    <UserProvider fetchMe={getMe}>
      <Suspense>
        <Constructor />
      </Suspense>
    </UserProvider>
  </Auth>
)

export default injectSheet(styles)(FinishSignup)
